var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapBox"},[_c('div',{staticClass:"unifiedBox"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.titleText))]),_c('van-loading',{attrs:{"color":"#1989fa"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }